// src/.../ProviderValidation.tsx
import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { FaCheckCircle, FaBuilding, FaHashtag, FaPhone, FaEnvelope } from 'react-icons/fa';
import './ProviderValidation.scss';

export interface ProviderPrep {
  found: { id: number; rut: string; name: string } | null;
  not_found: { rut: string; name: string } | null;
}

interface Props {
  provider: ProviderPrep;
  form: { rut: string; name: string; phone_number?: string; email?: string };
  setForm: React.Dispatch<React.SetStateAction<{ rut: string; name: string; phone_number?: string; email?: string }>>;
}

const ProviderValidation: React.FC<Props> = ({ provider, form, setForm }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  return (
    <div className="provider-validation-step">
      <h5>1. Validar Proveedor</h5>

      {provider.found ? (
        <div className="provider-found-card">
          <div className="card-header">
            <FaCheckCircle className="success-icon" />
            <span>Proveedor Encontrado en el Sistema</span>
          </div>
          <div className="card-body">
            <div className="info-item">
              <strong>Nombre:</strong>
              <span>{provider.found.name}</span>
            </div>
            <div className="info-item">
              <strong>RUT:</strong>
              <span>{provider.found.rut}</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="provider-new-form">
          <p className="form-description">
            No se encontró un proveedor existente. Por favor, confirma o corrige los siguientes datos para crearlo.
          </p>
          <div className="form-grid">
            <Form.Group>
              <Form.Label>RUT del Proveedor</Form.Label>
              <InputGroup>
                <InputGroup.Text><FaHashtag /></InputGroup.Text>
                <Form.Control name="rut" value={form.rut} onChange={handleChange} />
              </InputGroup>
            </Form.Group>

            <Form.Group>
              <Form.Label>Nombre del Proveedor</Form.Label>
              <InputGroup>
                <InputGroup.Text><FaBuilding /></InputGroup.Text>
                <Form.Control name="name" value={form.name} onChange={handleChange} />
              </InputGroup>
            </Form.Group>

            <Form.Group>
              <Form.Label>Teléfono (Opcional)</Form.Label>
              <InputGroup>
                <InputGroup.Text><FaPhone /></InputGroup.Text>
                <Form.Control name="phone_number" value={form.phone_number || ''} onChange={handleChange} placeholder="Ej: +56 9 1234 5678" />
              </InputGroup>
            </Form.Group>

            <Form.Group>
              <Form.Label>Email (Opcional)</Form.Label>
              <InputGroup>
                <InputGroup.Text><FaEnvelope /></InputGroup.Text>
                <Form.Control name="email" type="email" value={form.email || ''} onChange={handleChange} placeholder="Ej: contacto@proveedor.com" />
              </InputGroup>
            </Form.Group>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProviderValidation;
